import { useLayout } from "@/lib/preFetch/preFetchLayout"
import { HeaderScroll } from "@jog/react-components"
import { newHeaderEvent } from "@jog/shared"
import { Logo } from "components"

import { HeaderNav } from "./Nav"
import { UspBar } from "./UspBar"

const CheckoutHeader = () => {
    const layout = useLayout()
    const logo = layout?.layout?.logo
    const { menu } = newHeaderEvent()
    return (
        <div className="w-full bg-white">
            <div className="flex h-20 w-full items-center justify-center">
                {!!logo?.url && (
                    <Logo
                        onClick={menu}
                        src={logo.url}
                        width={logo.dimensions.width}
                        height={logo.dimensions.height}
                        alt=""
                        aria-label="Cart page"
                        href="/cart"
                    />
                )}
            </div>
        </div>
    )
}
export const Header = ({ isCheckoutPage, isCartPage }: { isCheckoutPage: boolean; isCartPage: boolean }) => {
    if (isCheckoutPage) {
        return (
            <HeaderScroll>
                <CheckoutHeader />
            </HeaderScroll>
        )
    }
    return (
        <HeaderScroll>
            <UspBar />
            <HeaderNav isCartPage={isCartPage} />
        </HeaderScroll>
    )
}
